import { Button, Text, Heading, Img } from "./..";
import { Link, useLocation } from "react-router-dom";
import React, { useState } from "react";

export default function Header({ ...props }) {
  const location = useLocation();
  const currentPath = location.pathname;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCompanyMenuOpen, setIsCompanyMenuOpen] = useState(false);

  const getLinkClass = (path) => {
    return currentPath === path
      ? "text-[18px] font-bold tracking-[-0.54px] text-color_style-02_primary_blue-blue500"
      : "text-[18px] font-normal tracking-[-0.54px] text-color_style-01_neutrals-grey100 hover:font-bold hover:text-color_style-02_primary_blue-blue500";
  };

  const handleNavigation = (closeMenuCallback) => {
    // Scroll to the top and close any open menus
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (closeMenuCallback) closeMenuCallback();
  };

  return (
    <header
      {...props}
      className={`${props.className} flex items-center justify-between sticky top-0 z-10 px-10 py-[20px] bg-blue_gray-900 w-full`}
    >
      {/* Logo Section */}
      <div className="flex items-center">
        <Link
          to="/"
          style={{ textDecoration: "none", cursor: "pointer" }}
          onClick={() => handleNavigation()}
          className="flex items-center"
        >
          <Img
            src="/images/img_thumbs_up.svg"
            alt="Logo Image"
            className="h-[34px]"
          />
          <Heading
          size="headingxl"
          as="h6"
          className="ml-2 font-dmsans text-[18px] font-black leading-4 text-white"
          >
          Zwilling Labs
          </Heading>
        </Link>
        
      </div>

      {/* Desktop Menu */}
      <nav className="hidden md:flex items-center gap-6 w-full">
        <ul className="flex flex-wrap gap-[34px] w-full">
          {[{ to: "/", label: "Home" }, { to: "/solutions", label: "Solutions" }].map(
            (item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  style={{ textDecoration: "none" }}
                  onClick={() => handleNavigation()}
                >
                  <Text as="p" className={getLinkClass(item.to)}>
                    {item.label}
                  </Text>
                </Link>
              </li>
            )
          )}
          {/* Company Dropdown */}
          <li className="relative">
            <button
              onClick={() => setIsCompanyMenuOpen(!isCompanyMenuOpen)}
              className="flex items-center text-[18px] font-normal tracking-[-0.54px] text-color_style-01_neutrals-grey100 hover:font-bold hover:text-color_style-02_primary_blue-blue500"
            >
              Company
              <Img
                src="/images/img_arrowdown_color_style_02_primary_blue_blue500.svg"
                alt="Expand Icon"
                className="ml-2 h-4 w-4"
              />
            </button>
            {isCompanyMenuOpen && (
              <ul className="absolute top-8 left-0 w-40 bg-blue_gray-900 shadow-lg rounded-md">
                <li>
                  <Link
                    to="/aboutus"
                    className="block px-4 py-2 hover:bg-blue_gray-700 text-white"
                    onClick={() => handleNavigation(() => setIsCompanyMenuOpen(false))}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/aboutus#team-section"
                    className="block px-4 py-2 hover:bg-blue_gray-700 text-white"
                    onClick={() => handleNavigation(() => setIsCompanyMenuOpen(false))}
                  >
                    Leadership
                  </Link>
                </li>
              </ul>
            )}
          </li>
          {[{ to: "/blogs", label: "Blogs" }, { to: "/career", label: "Careers" }, { to: "/contactus", label: "Contact Us" }].map(
            (item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  style={{ textDecoration: "none" }}
                  onClick={() => handleNavigation()}
                >
                  <Text as="p" className={getLinkClass(item.to)}>
                    {item.label}
                  </Text>
                </Link>
              </li>
            )
          )}
        </ul>
        <Link to="/bookademo" style={{ textDecoration: "none", cursor: "pointer" }}>
          <Button
            size="xl"
            shape="round"
            className="ml-5 rounded-[10px] px-[26px] font-bold tracking-[-0.60px] sm:px-5"
            onClick={() => handleNavigation()}
          >
              Get a Demo
          </Button>
        </Link>

      </nav>

      {/* Mobile Menu Button */}
      <button
        className="md:hidden text-white"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        <Img src="/images/img_menu.svg" alt="Menu Icon" className="h-6 w-6 fill-white" />
      </button>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <nav className="absolute top-[80px] left-0 w-full bg-blue_gray-900 p-4 shadow-lg md:hidden">
          <ul className="flex flex-col gap-4 w-full">
            {[{ to: "/", label: "Home" }, { to: "/solutions", label: "Solutions" }].map(
              (item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    style={{ textDecoration: "none" }}
                    onClick={() =>
                      handleNavigation(() => setIsMobileMenuOpen(false))
                    }
                  >
                    <Text as="p" className={getLinkClass(item.to)}>
                      {item.label}
                    </Text>
                  </Link>
                </li>
              )
            )}
            {/* Company Dropdown in Mobile */}
            <li>
              <button
                onClick={() => setIsCompanyMenuOpen(!isCompanyMenuOpen)}
                className="flex items-center text-[18px] font-normal tracking-[-0.54px] text-color_style-01_neutrals-grey100 hover:font-bold hover:text-color_style-02_primary_blue-blue500"
              >
                Company
                <Img
                  src="/images/img_arrowdown_color_style_02_primary_blue_blue500.svg"
                  alt="Expand Icon"
                  className="ml-2 h-4 w-4"
                />
              </button>
              {isCompanyMenuOpen && (
                <ul className="flex flex-col gap-2 mt-2">
                  <li>
                    <Link
                      to="/aboutus"
                      className="text-white hover:underline"
                      onClick={() =>
                        handleNavigation(() => {
                          setIsCompanyMenuOpen(false);
                          setIsMobileMenuOpen(false);
                        })
                      }
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/aboutus#team-section"
                      className="text-white hover:underline"
                      onClick={() =>
                        handleNavigation(() => {
                          setIsCompanyMenuOpen(false);
                          setIsMobileMenuOpen(false);
                        })
                      }
                    >
                      Leadership
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            {[{ to: "/blogs", label: "Blogs" }, { to: "/career", label: "Careers" }, { to: "/contactus", label: "Contact Us" }].map(
              (item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    style={{ textDecoration: "none" }}
                    onClick={() =>
                      handleNavigation(() => setIsMobileMenuOpen(false))
                    }
                  >
                    <Text as="p" className={getLinkClass(item.to)}>
                      {item.label}
                    </Text>
                  </Link>
                </li>
              )
            )}
          </ul>
          <Button
            size="xl"
            shape="round"
            className="mt-4 w-full rounded-[10px] px-[26px] font-bold tracking-[-0.60px]"
            onClick={() => handleNavigation(() => setIsMobileMenuOpen(false))}
          >
            <Link
              to="/contactus"
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              Get a Demo
            </Link>
          </Button>
        </nav>
      )}
    </header>
  );
}
